export default __webpack_public_path__ + "static/media/leon-do.1b52546b.jpeg";